exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-dialog {\r\n    font-size: 13px;\r\n    padding: 60px 60px 60px 60px;\r\n    background-color: white;\r\n    border-radius: 0 0 5px 5px;\r\n}\r\n\r\n.content-values {\r\n    padding: 30px;\r\n    background-color: white;\r\n    height: 300px;\r\n    overflow: auto;\r\n}\r\n\r\n.container-data {\r\n    border: 2px solid #CCCCCC;\r\n}\r\n\r\n.title-seccion {\r\n    padding: 20px;\r\n    background-color: #E2E7EB;\r\n}\r\n\r\n.values-seccion {\r\n    padding: 20px;\r\n}\r\n\r\nh2 {\r\n    margin: 0;\r\n}\r\n\r\n.subtitle {\r\n    margin-top: 20px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\np.text-buttons {\r\n    margin-top: 10px;\r\n    margin-bottom: 0;\r\n}\r\n\r\n.button-full {\r\n    width: 100%;\r\n}\r\n\r\np.center-content {\r\n    text-align: center;\r\n}\r\n\r\n.title-m-center {\r\n    text-align: center;\r\n    margin: 20px 0;\r\n}\r\n\r\n.icon-noty {\r\n    margin-bottom: 20px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/dialogos/sugerida/sugerida.component.css
// module id = ../../../../../src/app/components/dialogos/sugerida/sugerida.component.css
// module chunks = main